import Logo from './logo'

export {Logo}

export default Logo
